//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
export default {
  name: 'FibModal',
  props: {
    autoClose: {
      type: Boolean,
      default: false
    },
    closeButton: {
      type: Boolean,
      default: false
    },
    full: {
      type: Boolean,
      default: false
    },
    noBackdropDismiss: {
      type: Boolean,
      default: false
    },
    noEscDismiss: {
      type: Boolean,
      default: false
    },
    noRouteDismiss: {
      type: Boolean,
      default: false
    },
    persistent: {
      type: Boolean,
      default: false
    },
    position: {
      type: String,
      default: 'standard'
    },
    small: {
      type: Boolean,
      default: false
    },
    xsmall: {
      type: Boolean,
      default: false
    },
    value: {
      type: Boolean,
      default: false
    },
    noPadding: {
      type: Boolean,
      default: false
    },
    align: {
      type: String,
      default: 'center'
    },
    closeInverse: {
      type: Boolean,
      default: false
    },
    transitionShow: {
      type: String,
      default: 'scale'
    },
    transitionHide: {
      type: String,
      default: 'scale'
    },
    restrictContentWidth: {
      type: Boolean,
      default: false
    },
    closeButtonTestIdIdentifier: {
      type: String,
      default: 'default'
    }
  },
  computed: {
    theme: function theme() {
      return this.$store.getters['theme/theme'];
    },
    style: function style() {
      if (this.align) {
        return {
          textAlign: this.align,
          fontFamily: this.theme.fontFamily
        };
      }

      return {
        fontFamily: this.theme.fontFamily
      };
    }
  }
};